export const canPushProduct = () => () => {
    return function (nodes) {
        return [...nodes].filter(
            node => this.actions.canPushProduct(node)
        )
    }
}

export const pushProduct = () => () => {
    return async function (nodes) {
        await this.execute(
            () => this.runParallelAction(
                () => this.actions.pushProduct(nodes),
                {action: '更新制品'},
            )
        )
    }
}
